import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { getWalletList } from "actions/wallet/actions";

import WalletFilers from "views/pages/wallet/filters";
import CommonTable from "views/lib/components/CommonTable";

const Wallet = ({
                  getList,
                  list
                }) => {
  const getColumns = () => [
    {
      id: "id",
      Header: "#",
      accessor: "id",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/users/${original.id}`}>
          {original.id}
        </Link>
      ),
      width: 140
    },
    {
      id: "balance",
      Header: "Balance",
      accessor: "balance",
      width: 100
    },
    {
      id: "debt",
      Header: "Debt Total",
      accessor: "debts",
      sortable: false,
      // eslint-disable-next-line react/display-name,no-return-assign
      Cell: ({ original }) => (Array.isArray(original.debts)
        // eslint-disable-next-line no-return-assign
        ? Math.floor(original.debts.reduce((prev, current) => {
          prev += current.amount;
          return prev;
        }, 0))
        : 0),
      width: 100
    },
    {
      id: "currency",
      Header: "Currency",
      accessor: "currency",
      width: 90
    },
    {
      id: "card",
      Header: "Card",
      accessor: "card",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (original.card ? (
        <div>
          {original.card.cardholder ? original.card.cardholder : "Holder Not Set"}<br/>
          {original.card.cardMask ? original.card.cardMask : ""}({original.card.bankType ? original.card.bankType : ""})<br/>
          {original.card.date ? moment(original.card.date)
            .format("YYYY-MM-DD") : ""}
        </div>
      ) : ""),
      style: {
        whiteSpace: "unset"
      }
    },
    {
      Header: "Created Date",
      accessor: "creationDate",
      Cell: ({ original }) => moment(original.creationDate)
        .format("HH:mm YYYY-MM-DD"),
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={WalletFilers}
      searchHookProps={{
        size: 20,
        sort: "id,asc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.wallet.walletList,
});

const mapStateToDispatch = dispatch => ({
  getList: bindActionCreators(getWalletList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Wallet);



// WEBPACK FOOTER //
// ./src/views/pages/wallet/index.js